import stateOptions from '../../forms/options/state';
import _ from 'lodash';

const locationHelpers = {};

locationHelpers.prepEdit = (data) => {
    let stateIndex = _.findIndex(stateOptions, { value: data.state.value } )
    if (stateIndex !== -1) data.state.displayValue = stateOptions[stateIndex].name;
    return data
}

export default locationHelpers;



/** WEBPACK FOOTER **
 ** ./src/helpers/locations/buildValues.js
 **/